import { useEffect, useState } from 'react';

const UnlayerEditor = ({ design, editorRef, displayMode, mergeTags, tools, onLoad, editorHeight, projectId }) => {
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    setEditorLoaded(false);
  }, [projectId]);

  useEffect(() => {
    if (!editorLoaded) {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
      editorRef.current = window.unlayer.createEditor({
        version: '1.270.0',
        id: 'editor-container',
        projectId,
        displayMode,
        mergeTags,
        tools,
        features: {
          smartMergeTags: false,
        },
      });

      editorRef.current.addEventListener('design:loaded', () => {
        if (typeof onLoad === 'function') {
          onLoad();
        }
      });

      editorRef.current.addEventListener('editor:ready', () => {
        editorRef.current.loadDesign(design);
        setEditorLoaded(true);
      });
    }
  }, [editorRef, displayMode, mergeTags, tools, design, onLoad, editorHeight, projectId, editorLoaded]);

  return (
    <div id="editor-container" style={{ marginLeft: '-20px', minHeight: editorHeight, height: editorHeight }}></div>
  );
};

export default UnlayerEditor;
